import { QueryObserverOptions, useQuery } from "react-query";
import { PaymentOption } from "../@types";
import { APIError, APIResponse, API_URL, get } from "../api";

function usePaymentCheckoutOptions(
  options?: QueryObserverOptions<APIResponse<PaymentOption[]>, APIError>
) {
  const {
    data: paymentOptions,
    isError,
    error,
    isLoading,
  } = useQuery<APIResponse<PaymentOption[]>, APIError>(
    "checkout-payment_options",
    async () =>
      await get(API_URL + "/commerce/cart/checkout/payment/options", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    { ...options }
  );

  return {
    paymentOptions,
    isError,
    error,
    isLoading,
  };
}

export default usePaymentCheckoutOptions;
